export default __webpack_public_path__ + "static/media/43-min.1ee2fd6a.jpg";